import React, { useState } from "react";

const ClientSuccess = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState("");

  const testimonials = [
    {
      text: "Navigating the complexities of high-level tax strategy requires a partner who understands more than just the numbers. Alpha CPA's team demonstrated unrivaled precision in auditing our international holdings.",
      role: "Managing Partner, Convery & Associates",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      text: "Alpha CPA has transformed our financial architecture. Their heritage of excellence is evident in how they handle our enterprise-scale reporting with absolute dedication and a level of strategic foresight that has significantly bolstered our market position.",
      role: "CFO, Global Tech Solutions",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      text: "The transition to Alpha CPA was seamless. They inherited a decade of complex accounting data and immediately identified efficiencies that had been overlooked for years. They aren't just accountants; they are the guardians of our financial future.",
      role: "CEO, Thompson Capital Group",
      image: "https://randomuser.me/api/portraits/men/67.jpg",
    },
  ];

  const current = testimonials[activeIndex];

  const handlePrev = () => {
    if (isAnimating) return;
    setDirection("slide-right");
    setIsAnimating(true);
    setTimeout(() => {
      setActiveIndex((prev) =>
        prev === 0 ? testimonials.length - 1 : prev - 1,
      );
      setTimeout(() => {
        setIsAnimating(false);
        setDirection("");
      }, 50);
    }, 200);
  };

  const handleNext = () => {
    if (isAnimating) return;
    setDirection("slide-left");
    setIsAnimating(true);
    setTimeout(() => {
      setActiveIndex((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1,
      );
      setTimeout(() => {
        setIsAnimating(false);
        setDirection("");
      }, 50);
    }, 200);
  };

  return (
    <section className="client-success-section">
      <div className="container">
        <div className="section-wrapper flex flex-row lg:flex-row gap-16 lg:gap-16 items-center">
          {/* Section Heading */}
          <div className="heading-wrapper lg:w-1/3 text-center lg:text-left mb-12 lg:mb-0">
            <h2 className="section-title lg:text-left leading-tight">
              <span className="block">Clients</span>
              <span className="block">Success</span>
              <span className="block">Stories</span>
            </h2>
            <div className="gold-underline mx-auto lg:mx-0"></div>
          </div>

          {/* Testimonial Card */}
          <div className="testimonial-card lg:w-2/3 w-full">
            {/* Floating Quote Icon */}
            <div className="quote-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 21c3 0 7-1 7-8V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h2c0 2.2-1.8 4-4 4v2zm11 0c3 0 7-1 7-8V5c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h2c0 2.2-1.8 4-4 4v2z" />
              </svg>
            </div>

            {/* Card Content with Animation */}
            <div
              className={`card-content-wrapper ${isAnimating ? direction : ""}`}
            >
              <div className="card-content">
                <img
                  src={current.image}
                  alt={current.name}
                  className="profile-image"
                />
                <div className="text-content">
                  <p className="testimonial-text">{current.text}</p>
                  <h4 className="client-name">
                    <span className="client-role">{current.role}</span>
                  </h4>
                </div>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="nav-buttons">
              <button
                onClick={handlePrev}
                className="nav-btn"
                aria-label="Previous"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </button>
              <button
                onClick={handleNext}
                className="nav-btn"
                aria-label="Next"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientSuccess;
